import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsCountByProviders } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import { format } from "date-fns";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function RevenueByAdNetwork() {
  const navigation = useNavigate();
  const tableRef = useRef(null);

  const [range, setRange] = useState("weekly");
  const [tableData, setTableData] = useState([]);
  const [metaData, setMetaData] = useState({});

  const getAdsCountByProviders = async (rng = range) => {
    const res = await fetchAdsCountByProviders(rng);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      setMetaData(res?.data?.metadata || {});
    } else {
      handleErrors(res, navigation);
    }
  };

  const handleChangeRange = async (str) => {
    setRange(str);
    await getAdsCountByProviders(str);
  };

  const chartData = {
    labels: tableData?.map((item) => item?.provider?.toUpperCase()),
    datasets: [
      {
        label: "Total Ads",
        data: tableData?.map((item) => item?.total_ads),
        backgroundColor: "rgba(54, 162, 235, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#fff" } },
    },
    scales: {
      x: { ticks: { color: "#fff" } },
      y: { beginAtZero: true, ticks: { color: "#fff" } },
    },
  };

  useEffect(() => {
    getAdsCountByProviders();
  }, []);
  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = tableData.map((item) => {
      return [item?.provider.toUpperCase(), item?.total_ads];
    });

    const config = {
      data: rows,
      columns: [{ title: "Ad Network" }, { title: "Total Ads" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [tableData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Duration</h5>
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <Form.Select
                className="bg-dark text-light border-light"
                value={range}
                onChange={(e) => handleChangeRange(e.target.value)}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="yearly">Yearly</option>
              </Form.Select>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Ads by Network</h5>
          <p className="card-text">
            Compare number of ads from different ads-providers
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {tableData.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
          <div className="constainer-fluid mt-2">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">
                  {metaData?.from &&
                    `Records from  ${format(metaData.from, 'PP')} to ${format(new Date(), 'PP')}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Revenue Chart</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default RevenueByAdNetwork;
